module.exports = __webpack_public_path__ + "img/status_2.93cd9f47.svg";